<template>
  <div :class="['card-body', props.class]">
    <slot />
  </div>
</template>

<script setup>
/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
})
</script>
